import RedHatCloudServicesList from './red_hat_cloud_services_list';
import RedHatCloudServicesRedirect from './red_hat_cloud_services_redirect';
ManageIQ.component.addReact('RedHatCloudServicesList', RedHatCloudServicesList);
ManageIQ.component.addReact('RedHatCloudServicesRedirect', RedHatCloudServicesRedirect);
